import React from 'react';
import { connect } from 'react-redux';
import { Route, withRouter } from 'react-router-dom';
import {
  getUser,
  getSub as getSprintSub,
  getAttSub,
  getTracfoneSub,
  getTracfoneSubNotFoundFromFind,
  getIsAdmin,
  getIncludedInGroups,
  getLoggedInUser,
  getSubNotFoundFromFind,
  getAttSubNotFoundFromFind,
  getSubUpcomingPlan,
  getAttSubUpcomingPlan,
  getPlan,
  getAttPlan,
  getTracfonePlan,
  getSimoSub,
  getSimoSubNotFoundFromFind,
  getQuickSub,
  getQuickSubNotFoundFromFind,
} from '../reducers';

const emptyFunction = () => {};

const withSub = (
  DecoratedComponent,
  getSub,
  getSubNotFoundFromFind,
  path,
  getUpcomingPlan,
  getPlan,
) => {
  let WithSub = ({ children, ...props }) => {
    return React.createElement(DecoratedComponent, props, children);
  };

  const mapStateToProps = (
    state,
    {
      match: {
        params: { subId },
      },
    },
  ) => {
    const sub = getSub(state, subId);
    const userId = sub && sub.user_profile;
    const upcomingPlanObject = getUpcomingPlan(state, subId);
    const upcomingPlanId =
      upcomingPlanObject && upcomingPlanObject[0] && upcomingPlanObject[0].plan;

    return {
      notFound: getSubNotFoundFromFind(state),
      sub,
      subId,
      userId,
      upcomingPlanId,
      upcomingPlan: upcomingPlanId && getPlan(state, upcomingPlanId),
      upcomingPlanDetails: upcomingPlanObject && upcomingPlanObject[0],
      user: getUser(state, userId),
      loggedInUser: getLoggedInUser(state),
      isAdmin: getIsAdmin(state),
      isReseller: getIncludedInGroups(state, ['RESELLER']),
      isBusiness: getIncludedInGroups(state, ['BUSINESS']),
      isManager: getIncludedInGroups(state, ['MANAGER']),
      isAgent: getIncludedInGroups(state, ['AGENT']),
      isAdminOrAgentOrBillingOrManager: getIncludedInGroups(state, [
        'ADMIN',
        'AGENT',
        'BILLING',
        'MANAGER',
      ]),
      isAdminOrManagerOrBillingOrReseller: getIncludedInGroups(state, [
        'ADMIN',
        'MANAGER',
        'BILLING',
        'RESELLER',
      ]),
    };
  };

  WithSub = withRouter(connect(mapStateToProps, null)(WithSub));

  const WithSubRoute = ({ children, ...props }) => (
    <Route
      path={path}
      render={(routeProps) => <WithSub {...props} {...routeProps} />}
    />
  );

  return WithSubRoute;
};

export const withAttSub = (DecoratedComponent) =>
  withSub(
    DecoratedComponent,
    getAttSub,
    getAttSubNotFoundFromFind,
    '/att/subscriptions/:subId',
    getAttSubUpcomingPlan,
    getAttPlan,
  );
export const withTracfoneSub = (DecoratedComponent) =>
  withSub(
    DecoratedComponent,
    getTracfoneSub,
    getTracfoneSubNotFoundFromFind,
    '/tracfone/subscriptions/:subId',
    emptyFunction,
    getTracfonePlan,
  );
export const withSprintSub = (DecoratedComponent) =>
  withSub(
    DecoratedComponent,
    getSprintSub,
    getSubNotFoundFromFind,
    '/subscriptions/:subId',
    getSubUpcomingPlan,
    getPlan,
  );
export const withSimoSub = (DecoratedComponent) =>
  withSub(
    DecoratedComponent,
    getSimoSub,
    getSimoSubNotFoundFromFind,
    '/simo/subscriptions/:subId',
    () => null,
    () => null,
  );
export const withQuickSub = (DecoratedComponent) =>
  withSub(
    DecoratedComponent,
    getQuickSub,
    getQuickSubNotFoundFromFind,
    '/quick/subscriptions/:subId',
    () => null,
    () => null,
  );

export default withSprintSub;
